import styled from "styled-components";


export const Title = styled.h1`
padding: 15px;
font-size: var(--general-page-header-font-size);
`
export  const SearchWrapper = styled.div`
width: 360px;
@media (max-width: 991.98px){
    width: 60%;
}
@media (max-width: 600px){
    width: 100%;
}
padding-top:10px;
padding-bottom: 15px;
`

export const ClearFilterWrapper = styled.div`
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    gap: 5px;
    padding: 20px 0;
    @media (max-width: 600px){
        padding: 0 0 12px 0;
        width: 100%;
    }
`
    
export const ClearFilterButton = styled.div`
    text-decoration: underline;
    cursor: pointer;
`


export const DirectoryHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 20px;
`